
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/disease-encyclopedia/[id]/[keyword]",
      function () {
        return require("private-next-pages/disease-encyclopedia/[id]/[keyword]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/disease-encyclopedia/[id]/[keyword]"])
      });
    }
  